<template>
  <div class="search-container">
    <img
      src="@/assets/images/icons/search-dark.svg"
      alt="#"
      v-if="theme == 'dark'"
    />
    <img
      src="@/assets/images/icons/search-medium.svg"
      alt="#"
      v-if="theme == 'medium'"
    />
    <img
      src="@/assets/images/icons/search-light.svg"
      alt="#"
      v-if="theme == 'light'"
    />

    <input
      type="text"
      placeholder="Type to filter"
      id="search-filter"
      @keyup="getSearchString"
    />
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "SearchFilter",
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
    filteredProjects() {
      return store.getters.getFilteredProjects;
    },
  },
  methods: {
    getSearchString: function (e) {
      let path = this.$route.path;
      let searchQuery = e.target.value;
      store.dispatch('setSearchLoader',true);

      if (path == "/" || path == "/dt" || path == "/executive"  || path == "/project-list") {
        if (searchQuery == "") {
          store.dispatch("setFilteredProjects", store.getters.getProjects);
        } else {
          store.dispatch(
            "setFilteredProjects",
            store.getters.getProjects.filter((item) =>
              item.ProjectName.includes(searchQuery)
            )
          );
        }
      }
      if (path == "/sector-detail") {
        if (searchQuery == "") {
          store.dispatch(
            "setFilteredSectorProjects",
            store.getters.getSectorProjects
          );
        } else {
          store.dispatch(
            "setFilteredSectorProjects",
            store.getters.getSectorProjects.filter((item) =>
              item.ProjectName.includes(searchQuery)
            )
          );
        }
      }

      setTimeout(()=> {
        store.dispatch('setSearchLoader',false);
      },1000)
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
.theme-dark.ar {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #537996;
    background: #071C2D;
    position: relative;
    // bottom: 0px;
    // left: 70px;

    img {
      position: absolute;
      left: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
      text-indent: 30px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #537996);
    }
  }
}
.theme-medium.ar {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #c6e9f0;
    background: #628086;
    position: relative;
    // bottom: 0px;
    // left: 70px;

    img {
      position: absolute;
      left: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, #c6e9f0);
      text-indent: 30px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #c6e9f0);
    }
  }
}
.theme-light.ar {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #dcdcdc;
    background: #F3F3F3;
    position: relative;
    // bottom: 0px;
    // left: 70px;

    img {
      position: absolute;
      left: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, #7D7D7D);
      text-indent: 30px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #7D7D7D);
    }
  }
}
.theme-dark.en {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #537996;
    background: #071C2D;
    position: relative;
    // bottom: 0px;
    // right: 70px;

    img {
      position: absolute;
      right: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, $v3-dark-primarytext);
      text-indent: 30px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #537996);
    }
  }
}
.theme-medium.en {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #c6e9f0;
    background: #628086;
    position: relative;
    // bottom: 0px;
    // right: 70px;

    img {
      position: absolute;
      right: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, #c6e9f0);
      text-indent: 20px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #c6e9f0);
    }
  }
}
.theme-light.en {
  .search-container {
    width: 250px;
    height: 56px;
    border-radius: 28px;
    // border: 1px solid #dcdcdc;
    background: #F3F3F3;
    position: relative;
    // bottom: 0px;
    // right: 70px;

    img {
      position: absolute;
      right: 10px;
      top: 12px;
    }

    input {
      @include remove-input-defaults;
      background: none;
      border: none;
      width: 80%;
      height: 56px;
      @include apply-font($almarai, 400, 14px, #7D7D7D);
      text-indent: 30px;
    }
    input::-webkit-input-placeholder {
      @include apply-font($almarai, 400, 14px, #7D7D7D);
    }
  }
}
</style>